exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modal-inner {\n  background: white;\n  padding: 20px 20px;\n  position: relative; }\n  #modal-inner #modal-inner {\n    -webkit-box-shadow: 1px 6px 31px 7px rgba(0, 0, 0, 0.75);\n    -moz-box-shadow: 1px 6px 31px 7px rgba(0, 0, 0, 0.75);\n    box-shadow: 1px 6px 31px 7px rgba(0, 0, 0, 0.75); }\n\n@media only screen and (max-width: 768px) {\n  #react-aria-modal-dialog {\n    margin: 0px;\n    top: 0px;\n    padding: 0;\n    width: 100%; } }\n\n@media only screen and (min-width: 768px) {\n  #react-aria-modal-dialog {\n    width: 80% !important;\n    padding-top: 100px; } }\n", ""]);

// exports
